import React from "react";
import styles from "../styles.module.scss";
import { formatTick } from "../utils/dateUtils";

interface GanttTimelineHeaderCellProps {
  ticks: Date[];
  todayPct: number;
}

export const GanttTimelineHeaderCell: React.FC<GanttTimelineHeaderCellProps> = ({
  ticks,
}) => {
  return (
    <div className={styles.timelineHeaderCell}>
      <div className={styles.ticksContainer}>
        {ticks.map((t, i) => {
          const leftPct = (i / Math.max(ticks.length - 1, 1)) * 100;
          return (
            <span
              key={i}
              className={styles.tickLabel}
              style={{ left: `${leftPct}%` }}
            >
              {formatTick(t)}
            </span>
          );
        })}
      </div>
    </div>
  );
};
